'use client';

import { plPL as plPLCore } from '@mui/material/locale';
import { plPL as plPLDate } from '@mui/x-date-pickers/locales';
import { pl as plAdapter } from 'date-fns/locale';
import { merge } from 'lodash-es';

import { DEFAULT_LOCALE } from '@/constants/defaults';
import commonMessages from '@/i18n/locale/pl/common.json';

export const allLangs = [
  {
    label: commonMessages.enums.languages.pl,
    value: 'pl',
    systemValue: merge(plPLDate, plPLCore),
    adapterLocale: plAdapter,
    icon: '🇵🇱',
    numberFormat: {
      code: DEFAULT_LOCALE,
      currency: 'PLN',
    },
  },
];
